import type { FC } from 'react';
import type { IconProps } from './types';

const Edit: FC<IconProps> = ({ color = 'currentColor', size = 24, strokeWidth = 1.5, ...props }) => {
  const calculatedStrokeWidth = (Number(strokeWidth) * 24) / Number(size);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      color={color}
      fill="none"
      stroke={color}
      strokeWidth={calculatedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M3.78181 16.3092L3 21L7.69086 20.2182C8.50544 20.0825 9.25725 19.6956 9.84119 19.1116L20.4198 8.53288C21.1934 7.75922 21.1934 6.5049 20.4197 5.73126L18.2687 3.58024C17.495 2.80658 16.2406 2.80659 15.4669 3.58027L4.88841 14.159C4.30447 14.7429 3.91757 15.4947 3.78181 16.3092Z" />
      <path d="M14 6L18 10" />
    </svg>
  );
};

export default Edit;
